import { render, staticRenderFns } from "./PropagandistShow.vue?vue&type=template&id=1481fe76&"
import script from "./PropagandistShow.vue?vue&type=script&lang=js&"
export * from "./PropagandistShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports